// apps/web/src/router.tsx
import { createBrowserRouter, Navigate } from 'react-router-dom'
import { Layout } from './routes/layout'
import { LoginPage } from './routes/login'
import { DashboardPage } from './routes/dashboard'
import { ConversationsPage } from './routes/conversations'
import { ConversationDetailPage } from './routes/conversation-detail'
import { ChannelsPage } from './routes/channels'
import { AssignmentRulesPage } from './routes/assignment-rules'
import { AnalyticsPage } from './routes/analytics'
import { QuickRepliesPage } from './routes/quick-replies'
import { SettingsPage } from './routes/settings'
import { WorkingHoursPage } from './routes/settings-working-hours'
import { AutoReplyPage } from './routes/settings-auto-reply'
import { WidgetSettingsPage } from './routes/settings-widget'
import { AuthGuard } from './components/auth-guard'

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'conversations', element: <ConversationsPage /> },
      { path: 'conversations/:id', element: <ConversationDetailPage /> },
      { path: 'channels', element: <ChannelsPage /> },
      { path: 'assignment-rules', element: <AssignmentRulesPage /> },
      { path: 'analytics', element: <AnalyticsPage /> },
      { path: 'quick-replies', element: <QuickRepliesPage /> },
      {
        path: 'settings',
        element: <SettingsPage />,
        children: [
          { index: true, element: <Navigate to="working-hours" replace /> },
          { path: 'working-hours', element: <WorkingHoursPage /> },
          { path: 'auto-reply', element: <AutoReplyPage /> },
          { path: 'widget', element: <WidgetSettingsPage /> },
        ],
      },
    ],
  },
])
